import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Link } from '@inertiajs/react';
import { Star } from 'lucide-react';

export function HomeHero() {
    return (
        <section className="grid items-center gap-10 md:grid-cols-[1.1fr_0.9fr]">
            <div className="space-y-6">
                <span className="inline-flex items-center gap-2 rounded-full bg-slate-900/5 px-4 py-1 text-sm font-semibold text-slate-700 dark:bg-white/10 dark:text-white">
                    <Star className="size-4" />
                    Modern stays, softer edges
                </span>
                <h1 className="text-4xl leading-tight font-semibold tracking-tight text-balance text-slate-900 sm:text-5xl dark:text-white">
                    Your serene motel escape curated for the way you travel now.
                </h1>
                <p className="max-w-xl text-lg text-slate-600">
                    Slip into calming spaces, minimal fuss, and human
                    hospitality. From arrival to after-dark, every moment is
                    designed to feel effortless.
                </p>
                <div className="flex flex-wrap items-center gap-3">
                    {/* <Button size="lg" asChild>
                        <Link href={register()}>Plan my stay</Link>
                    </Button> */}
                    <Button
                        size="lg"
                        variant="outline"
                        className="border-slate-200 text-slate-700 hover:border-slate-300 dark:border-slate-700 dark:bg-transparent dark:hover:border-slate-500"
                    >
                        <Link href="#highlights">Explore spaces</Link>
                    </Button>
                </div>
                <div className="flex items-center gap-4 pt-2 text-sm text-slate-500 dark:text-slate-400">
                    <div className="flex items-center gap-2">
                        <div className="h-2.5 w-2.5 rounded-full bg-emerald-500" />
                        Concierge chat within moments
                    </div>
                    <div className="flex items-center gap-2">
                        <div className="h-2.5 w-2.5 rounded-full bg-sky-500" />
                        Flexible check-in & out
                    </div>
                </div>
            </div>
            <Card className="relative overflow-hidden border-none bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 p-10 text-white shadow-xl">
                <div className="space-y-5">
                    <p className="text-sm tracking-[0.3rem] text-slate-300 uppercase">
                        Signature experience
                    </p>
                    <h2 className="text-3xl leading-tight font-semibold">
                        Courtyard glow evenings
                    </h2>
                    <p className="text-slate-200">
                        Sink into curated playlists, soft lighting, and crafted
                        refreshments under the open sky. Reserved seating with
                        ambient heaters keeps every night timeless.
                    </p>
                    <div className="grid gap-3 text-sm text-slate-100">
                        <div className="flex items-center justify-between">
                            <span>Twilight welcome</span>
                            <span className="text-slate-300">7:30 PM</span>
                        </div>
                        <div className="flex items-center justify-between">
                            <span>Private tasting flight</span>
                            <span className="text-slate-300">8:05 PM</span>
                        </div>
                        <div className="flex items-center justify-between">
                            <span>Stargazer lounge</span>
                            <span className="text-slate-300">9:15 PM</span>
                        </div>
                    </div>
                </div>
                <div className="absolute inset-0 -z-10 bg-[radial-gradient(circle_at_top,_rgba(255,255,255,0.18),_transparent_55%)]" />
            </Card>
        </section>
    );
}
